module.exports = __webpack_public_path__ + "static/media/teknon@3x.791d099c.jpg";